// extracted by mini-css-extract-plugin
module.exports = {"instructions":"Instructions_instructions__5fSfF","alert":"Instructions_alert__O_Hog"};